import React from 'react';
import TabbedWorkspaceContainer from '../TabbedWorkspaceContainer/TabbedWorkspaceContainer';
import { Availability, AggregateLineOn } from '../../components';
import { aggregateLabelMap } from '../../staticData';

const AvailabilityView = ({ aggregate }) => {
  const tabs = [
    { label: 'Dispatch', component: Availability, props: { aggregate } },
    {
      label: 'Lineout Update',
      component: AggregateLineOn,
      props: { aggregate },
    },
  ];

  const title = aggregateLabelMap[aggregate];
  return <TabbedWorkspaceContainer isAggregate={true} pageTitle={title} tabs={tabs} />;
};

export default AvailabilityView;
